import { render, staticRenderFns } from "./profile.page.vue?vue&type=template&id=529d32e6&scoped=true&"
import script from "./profile.page.vue?vue&type=script&lang=js&"
export * from "./profile.page.vue?vue&type=script&lang=js&"
import style0 from "./profile.page.vue?vue&type=style&index=0&id=529d32e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d32e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VDataTable,VForm})
